const collection = "AOKanhaVolunteering";
const initialQuery = ({ uid, oppy }) => ({
  collection,
  where: [
    ["uid_added", "==", uid],
    ["oppy", "==", oppy],
  ],
  orderBy: [["date_added", "desc"]],
});

export const colors = {
  shade6: "#D3F3FF",
  shade5: "#C4E8F6",
  shade4: "#A5D1E6",

  shade0: "#04090b",
};

const config = {
  collection,
  // firestorePath: "preceptorspecialsittings2022",
  initialQuery,
  cachingKey: collection,
};
export default config;
